module.exports = __webpack_public_path__ + "static/media/app-info.04353961.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/app-info.svg
// module id = 458
// module chunks = 0